import * as Constants from './constants'

const initialState = {
  list: [],
  listUsers: [],
  item: {},
  type: Constants.CHECKIN_LIST_INITING,
  isRequesting: false,
  successful: false,
  messages: [],
  errors: [],
  formData: {}
}

const reducer = function checkinReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.CHECKIN_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
        isRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
      }

    case Constants.CHECKIN_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data.records,
        item: action.data,
        isRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.CHECKIN_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.CHECKIN_REPORT_REQUESTING:
      return {
        ...state,
        type: action.type,
        isRequesting: true,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
      }

    case Constants.CHECKIN_REPORT_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data.records,
        item: action.data,
        isRequesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.CHECKIN_REPORT_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isRequesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.CHECKIN_UPDATE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isRequesting: true,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
      }

    case Constants.CHECKIN_UPDATE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: action.payload.data,
        type: action.type,
        isRequesting: false,
        successful: true,
        messages: [{
          body: 'Check in thành công',
          time: new Date(),
        }]
      }

    case Constants.CHECKIN_UPDATE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isRequesting: false,
        successful: false,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.CHECKIN_REPORT_NVKD_REQUESTING:
      return {
        type: action.type,
        isRequesting: true,
      }

    case Constants.CHECKIN_REPORT_NVKD_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listNVKD: action.data,
        isRequesting: false,
      }

    case Constants.CHECKIN_REPORT_NVKD_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isRequesting: false,
      }

    case Constants.CHECKIN_REPORT_EXPORT_XLS_REQUESTING:
      return {
        ...state,
        type: action.type,
        isRequesting: true,
        formData: action.payload,
      }

    case Constants.CHECKIN_REPORT_EXPORT_XLS_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isRequesting: false,
        listEXP: action.data,
      }

    case Constants.CHECKIN_REPORT_EXPORT_XLS_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isRequesting: false,
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Checkin/reducer.js